import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { removeNote } from '../Redux/action';
import { updateNote } from '../Redux/action';


export default function AllNotes() {

  const notes = useSelector((state) => state.notes)
  console.log(notes)
  const dispatch = useDispatch();


  return (
    <>
    
     <div className='note'>
      {
        notes.map((note, index) => {
          return (
            <>
            <div className='note'>
            <div className="card" style={{width: "250px", height:"auto", margin:'1rem'}}>
                <div className="card-body">
                <a href="#" className="delete-btn"><img src='https://icons.veryicon.com/png/o/business/a-set-of-commercial-icons/notes-54.png' className='delete-btn'/></a>
                <a href="#" className="delete-btn" onClick={()=> dispatch(removeNote(index))}><img src='https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/Delete-button.svg/862px-Delete-button.svg.png' className='delete-btn'/></a>
                  <h5 className="card-title">{<b>{note.title}</b>}</h5>
                  <p className="card-text">{<i>{note.content}</i>}</p>
                </div>
              </div>

            </div>
              
            </>

          )
        })
      }

    </div>
    </>
  
  )
}

